import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerDichiarazioniIntentoPassiveModalComponent} from './worker-dichiarazioni-intento-passive-modal';

export const WorkerDichiarazioniIntentoPassiveModalModule: string = ng
    .module('worker-dichiarazioni-intento-passive-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerDichiarazioniIntentoPassiveModalComponent', WorkerDichiarazioniIntentoPassiveModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-dichiarazioni-intento-passive-modal/worker-dichiarazioni-intento-passive-modal.module.ts